import { useTranslation } from "react-i18next";
import { useGetFeedback360Result } from "../hooks";
import { Feedback360Summary } from "../types";
const PersonalFeedback = () => {
  const { t } = useTranslation("myArea");
  const { data: feedbackResult, isLoading } = useGetFeedback360Result();
  if (isLoading) {
    return (
      <div className="w-full text-center py-8">
        {t("assessments.feedback360.loading")}
      </div>
    );
  }
  if (!feedbackResult) {
    return (
      <div className="w-full text-center py-8">
        {t("assessments.feedback360.no_feedback_results")}
      </div>
    );
  }
  const { observedStrengths, developmentAreas, suggestedRoles } =
    feedbackResult as Feedback360Summary;
  return (
    <div className="w-full py-4">
      <div className="mb-6 ">
        <h3 className="text-lg font-bold mb-2">
          {t("assessments.feedback360.observed_strengths")}
        </h3>
        <p className=" p-2 whitespace-pre-line">
          {observedStrengths || t("assessments.feedback360.no_data_available")}
        </p>
      </div>
      <div className="mb-6">
        <h3 className="text-lg font-bold mb-2">
          {t("assessments.feedback360.development_areas")}
        </h3>
        <p className="p-2 whitespace-pre-line">
          {developmentAreas || t("assessments.feedback360.no_data_available")}
        </p>
      </div>
      <div className="mb-6">
        <h3 className="text-lg font-bold mb-2">
          {t("assessments.feedback360.suggested_roles")}
        </h3>
        {suggestedRoles && suggestedRoles.length > 0 ? (
          <div className="space-y-4">
            {suggestedRoles.map((role, index) => (
              <div
                key={index}
                className="p-2"
              >
                <div className="flex flex-col">
                  <span className="font-semibold text-gray-800 mb-2">
                    {role.role}
                  </span>
                  <div className="pl-3 border-l-2 border-gray-300 whitespace-pre-line">
                    <p className="">{role.roleDescription}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="">{t("assessments.feedback360.no_suggested_roles")}</p>
        )}
      </div>
    </div>
  );
};
export default PersonalFeedback;
